// src/components/ColorPicker/ColorPicker.js
import React, { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import './ColorPicker.css'

const ColorPicker = ({ value, onChange, label }) => {
	const [hexInput, setHexInput] = useState(value || '#ffffff')

	// Sincronizar el input de texto cuando cambia el valor externo
	useEffect(() => {
		setHexInput(value || '#ffffff')
	}, [value])

	// Cambio desde el input type="color"
	const handleColorChange = (e) => {
		const newColor = e.target.value
		setHexInput(newColor)
		onChange(newColor)
	}

	// Cambio desde el input de texto
	const handleHexInputChange = (e) => {
		let hex = e.target.value
		setHexInput(hex)

		// Agregar # si no lo tiene
		if (hex && !hex.startsWith('#')) {
			hex = '#' + hex
		}

		// Solo aplicar si es un hex válido de 6 caracteres
		if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
			onChange(hex)
		}
	}

	// Cuando pierde el foco, asegurar formato correcto
	const handleBlur = () => {
		let hex = hexInput
		if (hex && !hex.startsWith('#')) {
			hex = '#' + hex
		}
		if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
			setHexInput(hex)
			onChange(hex)
		} else {
			// Si no es válido, restaurar al valor actual
			setHexInput(value || '#ffffff')
		}
	}

	return (
		<Form.Group className="color-picker-group">
			{label && <Form.Label>{label}</Form.Label>}
			<div className="color-picker-container">
				{/* Muestra del color */}
				<div
					className="color-preview"
					style={{ backgroundColor: value || '#ffffff' }}
					title={value}
				/>
				{/* Input nativo de color */}
				<Form.Control
					type="color"
					value={value || '#ffffff'}
					onChange={handleColorChange}
					className="color-input"
				/>
				{/* Input de texto para hex */}
				<Form.Control
					type="text"
					value={hexInput}
					onChange={handleHexInputChange}
					onBlur={handleBlur}
					placeholder="#ffffff"
					className="hex-input"
					maxLength={7}
				/>
			</div>
		</Form.Group>
	)
}

export default ColorPicker
